import { SearchQuery } from "../code/search-query/search-query";
import ManagedGridView from "../controls/ManagedGridView";
import {
  programCategoriesViewColumns,
  mapProgramCategoriesViewQuery,
} from "./ProgramCategoriesView.default";
import { getProgramCategories } from "../repository/data.repository";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";
import { createGridRequest } from "../hooks/useGridRequest";

export interface ProgramCategoriesViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function ProgramCategoriesView(props: ProgramCategoriesViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={programCategoriesViewColumns}
      mapQuery={mapProgramCategoriesViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getProgramCategories, { retry: true })}
      pageSize={100}
      schema={{
        groups: [
          {
            controls: [
              { type: "textbox", name: "name", label: "Name" },
              { type: "textbox", name: "description", label: "Description" },
            ],
          },
        ],
      }}
      actions={(_record) => [
        {
          key: "update",
          label: "Edit",
          disabled: !permissions.can("CompanyProgramCategories", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          disabled: !permissions.can("CompanyProgramCategories", "delete"),
          danger: true,
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default ProgramCategoriesView;
